import { createSelector } from 'reselect';
import { IRootState } from '../../app/types/rootReducers.t';
import { getPayoutLastDeposit } from '../Withdrawal/withdrawalSelectors';
import _ from 'lodash';
import { DEPOSIT_PARAMS_INITIAL_STATE, DEPOSIT_STEPS } from './depositConstants';
import {
    calcDepositPromocodesBonusAmount
} from './components/DepositPromocodes/utils/calcDepositPromocodesBonusTotalAmount';
import { STATE_TX } from '../Account/components/TransactionHistory/transactionHistoryConstants';
import { getUserSelectedAccountType } from "../../app/appSelectors";
import { ACCOUNT_TYPES } from "../../app/appConstants";

export const getIsOpenDepositOnboarding = createSelector(
    getPayoutLastDeposit, (lastDeposit) => !lastDeposit
);

const moduleSelector = (state: IRootState) => state.deposit;

export const getDepositFormDataList = createSelector(moduleSelector, state => state.formDataList);
export const getDepositFormDataListError = createSelector(moduleSelector, state => state.formDataListError);
export const getDepositFormDataListIsLoading = createSelector(moduleSelector, state => state.formDataListIsLoading);

export const getDepositFormUserData = createSelector(moduleSelector, state => state.formUserData);
export const getDepositFormUserDataFormId = createSelector(moduleSelector, state => state.formUserDataFormId);
export const getDepositFormUserDataPaymentKey = createSelector(moduleSelector, state => state.formUserDataPaymentKey);
export const getDepositFormUserDataError = createSelector(moduleSelector, state => state.formUserDataError);
export const getDepositFormUserDataIsLoading = createSelector(moduleSelector, state => state.formUserDataIsLoading);

export const getDepositStepSelector = createSelector(moduleSelector, state => state.step);

export const getDepositParamsSelector = createSelector(moduleSelector, state => state.depositParams);
export const getIsDepositParamsEmptySelector = createSelector(getDepositParamsSelector, depositParams =>
    _.isEmpty(depositParams) || _.isEqual(depositParams, DEPOSIT_PARAMS_INITIAL_STATE));

export const getDepositAvailableMethodsSelector = createSelector(moduleSelector, state => state.availableMethods);
export const getDepositAvailableMethodsLoadingSelector = createSelector(moduleSelector, state => state.availableMethodsLoading);

export const getDepositFormSelector = createSelector(moduleSelector, state => state.form);

export const getDepositCreateSuccessPayloadSelector = createSelector(moduleSelector, state => state.depositCreateSuccessPayload);
export const getDepositCreateProcessSelector = createSelector(moduleSelector, state => state.depositCreateProcess);

export const getIsCheckDepositSurvey = createSelector(moduleSelector, state => state.isCheckDepositSurvey);

export const getDepositCreateBonusAmountSelector = createSelector(getDepositCreateSuccessPayloadSelector, depositCreateSuccessPayload => {
    const { account_promocode, transaction } = depositCreateSuccessPayload;
    const transactionAmount = parseFloat(transaction.amount);
    const promocodeBonusAmount = calcDepositPromocodesBonusAmount(transactionAmount, account_promocode) || 0;
    return parseFloat(depositCreateSuccessPayload.bonus?.amount) || promocodeBonusAmount || 0;
});

export const getIsShowDepositSlideHeaderBalanceSelector = createSelector(
    [getDepositStepSelector, getDepositCreateSuccessPayloadSelector], (step, depositCreateSuccessPayload) => {
        return step === DEPOSIT_STEPS.PAYMENT_DETAILS &&
            depositCreateSuccessPayload?.transaction?.state === STATE_TX.PROCESSING;
    },
);

export const getDepositErrorSelector = createSelector(moduleSelector, state => state.error);

export const getIncompleteDepositVisibleSelector = createSelector(moduleSelector, state => state.isIncompleteDepositVisible);
export const getIsIncompleteDepositClosedByUserSelector = createSelector(moduleSelector, state => state.isIncompleteDepositClosedByUser);
export const getIncompleteDepositSelector = createSelector(moduleSelector, state => state.incompleteDeposit);
export const getIsIncompleteDepositWidgetAvailableSelector = createSelector([getIncompleteDepositVisibleSelector, getIsIncompleteDepositClosedByUserSelector, getIncompleteDepositSelector, getUserSelectedAccountType], (isIncompleteDepositVisible, isIncompleteDepositClosedByUser, incompleteDeposit, selectedAccountType) => isIncompleteDepositVisible && !isIncompleteDepositClosedByUser && incompleteDeposit !== null && selectedAccountType === ACCOUNT_TYPES.LIVE);
